module.exports = __webpack_public_path__ + "img/chain_data.688258e3.png";